import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { BBResponseContainer } from "../carrier/response-container";
import { LiquidLevelDetectionRequest } from "../ngs-volume-adjustment/liquid-level-detection-request";
import { FragmentAnalysis } from "./model/fragment-analysis";
import { timeout, tap } from 'rxjs/operators';

@Injectable()
export class NgsFragmentAnalysisService {


  constructor(private http: HttpClient) {
  }

  // upload hemilton file and get FragmentAnalysisResponse
  uploadHemiltonFile(liquidLevelDetectionRequest: LiquidLevelDetectionRequest): Observable<BBResponseContainer> {
    let url = environment.BB_NGS_ENTRY_QC_URL + 'ngs/fragmentanalysis/extractconcentration';
    // tslint:disable-next-line:max-line-length
    return this.http.post<BBResponseContainer>(url, liquidLevelDetectionRequest).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
      error.url = url;
    }));
  }

  //Generate work files for uploaded samples
  generateFAWorkfiles(fragmentAnalysisRequest: FragmentAnalysis[]): Observable<BBResponseContainer> {
    let url = environment.BB_NGS_ENTRY_QC_URL + 'ngs/entryqc/fa/generateFAWorkFiles';
    return this.http.post<BBResponseContainer>(url, fragmentAnalysisRequest).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
      error.url = url;
    }));
  }

  getMachineList(): Observable<BBResponseContainer> {

    let url = environment.BB_MDMSERVICE_URL + 'admin/mdm/machine';
    let requestParam = new HttpParams();
    const options = url ? { params: requestParam } : {};

    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
  }

  // Get the available FAPlates
  getFAPlateList(): Observable<BBResponseContainer> {
    const url = environment.BB_NGS_ENTRY_QC_URL + 'ngs/fragmentanalysis/fa/plates';
    return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
      error.url = url;
    }));
  }

  updateSampleAssayType(fragmentAnalysisResponseList: FragmentAnalysis[]) : Observable<BBResponseContainer> {
    const url = environment.BB_NGS_ENTRY_QC_URL + 'ngs/fragmentanalysis/sample/assaytype';
    return this.http.put<BBResponseContainer>(url, fragmentAnalysisResponseList).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }))
  }
}
